import Vue from 'vue'
import Router from 'vue-router'
import HomePage from "./home/HomePage";
import { NotFoundPage } from "./shared/components";
import { scheduleRoutes } from './schedule';
import { paymentRoutes } from "./payment";
import {orderRoutes} from "./orders";

Vue.use(Router);

const appRoutes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            title: 'Nhà xe Hoàng công - Xe khách Hà Nội Quảng Ninh chạy cao tốc'
        }
    },
    {
        path: '*',
        name: 'not-found',
        component: NotFoundPage,
        meta: {
            title: 'Hoàng Công'
        }
    }
];

const routes = [...scheduleRoutes, ...paymentRoutes, ...orderRoutes, ...appRoutes];
const router = new Router({
    mode: 'history',
    routes
});

export default router;
